import { render, staticRenderFns } from "./forgotPassword.vue?vue&type=template&id=443e6410&scoped=true"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"
import style0 from "./forgotPassword.vue?vue&type=style&index=0&id=443e6410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443e6410",
  null
  
)

export default component.exports